import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class JanelaApuracaoTaxaMediaMaximaAgente extends BaseEntity{
    public ideTranche: number ;

	public  dataInicioJanela: Date;

	public  dataFimJanela: Date;

	public  dataFimExecucao: Date;

	public  dataUltimaExecucao: Date;

	public fechamentoRealizado: boolean;
	
	public usuarioResponsavel: string;
	
	public dataCriacao: Date;

	constructor(){
		super();
	}
}